import { render, staticRenderFns } from "./transactions-count-chart.vue?vue&type=template&id=24058746"
import script from "./transactions-count-chart.vue?vue&type=script&lang=js"
export * from "./transactions-count-chart.vue?vue&type=script&lang=js"
import style0 from "./transactions-count-chart.vue?vue&type=style&index=0&id=24058746&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports